import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useHealthSectionHttp } from '@/core/api/health-sections'
import { HealthSection, HealthSectionPayload } from '@/core/models/health-section'

export type HealthSectionCollection = {
    data: Array<HealthSection>,
    meta?: MetaPayload,
    links?: any
}

const state: HealthSectionCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const healthSectionCollection: Module<HealthSectionCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: HealthSectionCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: HealthSectionPayload) => {
                state.data.push(new HealthSection(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useHealthSectionHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: HealthSectionCollection): HealthSectionCollection => {
            return state
        }
    }
}